/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/src/services/apiClient";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { queryKeys } from "@/src/services/reactQuery/reactQueryService";

export default function useCheckProductDeletable(product: AbstractCase) {
  const url = `/case_deletion/get_case_deletion_possible_status/`;

  return useQuery({
    queryKey: queryKeys.item(url, product.id),
    queryFn: async function checkDeletable() {
      const result = await apiGet(url + product.id);
      return !result.hasAcquisitionPartnerAdvocard && !result.isAdvancedCase && !result.hasBookingEntry;
    },
  });
}
